<app-oib-service-subjekt-action></app-oib-service-subjekt-action>
<ntap-prime-common-itemview #itemView></ntap-prime-common-itemview>
